/*
 * Copyright (c) 2026 Oray Inc. All rights reserved.
 *
 * No Part of this file may be reproduced, stored
 * in a retrieval system, or transmitted, in any form, or by any means,
 * electronic, mechanical, photocopying, recording, or otherwise,
 * without the prior consent of Oray Inc.
 *
 * @Author: huangweiliang<huangweiliang@oray.com>
 * @Date: 2026-01-13
 * @LastEditors: huangweiliang<huangweiliang@oray.com>
 * @LastEditTime: 2026-01-13 18:42:39
 * @FileName: config.ts
 * @Description: []
 */

import { BridgeConfig } from './types'

export const DEFAULT_CLIENT_TYPE_CONFIGS: Record<string, BridgeConfig> = {
  // 向日葵 (通用)
  sun: {
    injectObjectNames: ['messageHandlers'],
  },
  // 向日葵 Flutter (App)
  'sun-flutter': {
    injectObjectNames: [],
    flutterMode: 'webchannel', // 使用 window.messageHandlers.WebChannel
  },
  // 蒲公英 (通用)
  pgy: {
    injectObjectNames: ['messageHandlers'],
  },
  // 蒲公英游戏 (Flutter)
  'pgy-game': {
    injectObjectNames: [],
    flutterMode: 'default', // standard inappwebview
  },
  // 蒲公英企业版 (Windows C++ 等，接收 Object)
  'pgy-ent': {
    injectObjectNames: [],
    payloadType: 'object', // 传递原始对象而非 JSON 字符串
  },
  // 鸿蒙 (WebChannel 模式)
  harmony: {
    injectObjectNames: [],
    harmonyMode: 'webchannel',
  },
  // 默认/通用
  default: {
    injectObjectNames: ['messageHandlers'],
    webkitHandlerName: undefined,
    payloadType: 'string',
  },
}

export const DEFAULT_CONFIG = {
  clientType: 'default',
  clientTypeConfigs: DEFAULT_CLIENT_TYPE_CONFIGS,
  globalBridgeName: 'OrayClientWebBridge',
}
